<!--公共底部 高春超 2018年1月22日10:29:59-->
<template>
  <div class="footer" :class="this.$route.meta.white ? 'white' : ''">
    <div class="wrapper"></div>
    <!--帮助中心-->
    <div id="faq">
      <div class="wrapper">
        <ul>
          <li v-for="menu in fMenu">
            <dl>
              <dt>{{ menu.name }}</dt>
              <dd v-for="child in menu.children">
                <i></i>
                <a
                  v-if="!child.router.path"
                  :href="child.router"
                  :title="child.name"
                  >{{ child.name }}</a
                >
                <router-link v-else :to="child.router" :title="child.name">{{
                  child.name
                }}</router-link>
              </dd>
            </dl>
          </li>
          <div class="clear"></div>
        </ul>
      </div>
    </div>
    <div id="footer">
      <div class="wrapper">
        <p>
          ©2015-现在 kxymall.com 版权所有 闽ICP备2023007687号
          <a target="_blank" :href="require('../../../assets/images/yyzz.jpg')"
            >营业执照</a
          >
        </p>
        <div style="width: 300px; margin: 0 auto; padding: 20px 0 0 0">
          <a
            target="_blank"
            :href="require('../../../assets/images/zzdx.jpg')"
            style="
              display: inline-block;
              text-decoration: none;
              height: 20px;
              line-height: 20px;
            "
          >
            <p
              style="
                float: left;
                height: 20px;
                line-height: 20px;
                margin: 0px 0px 0px 5px;
              "
            >
              增值电信业务经营许可证
            </p>
          </a>
        </div>
        <div style="width: 300px; margin: 0 auto; padding: 20px 0">
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35020602002793"
            style="
              display: inline-block;
              text-decoration: none;
              height: 20px;
              line-height: 20px;
            "
            ><img
              src="../../../assets/images/备案图标.png"
              style="float: left"
            />
            <p
              style="
                float: left;
                height: 20px;
                line-height: 20px;
                margin: 0px 0px 0px 5px;
                color: #939393;
              "
            >
              闽公网安备 35020602002793号
            </p>
          </a>
        </div>
        <!-- <p>©2015-现在 kxymall.com 开心云（北京）信息技术有限公司版权所有 <a target="_blank" href="https://beian.miit.gov.cn/">京ICP备2021006334号</a></p> -->
        <!-- <p>电信与信息服务业务经营许可证：京ICP证160544号 | <a :href="require('../../../assets/images/medicine_cert.jpg')" target="_blank">
            互联网药品信息服务资格证(京)-2016-0102</a></p> -->
        <!-- <p>广播电视节目制作经营许可证：（京）字第19400号 | 网络文化经营许可证：京网文（2021）2262-606号</p> -->
        <!-- <p>中华人民共和国增值电信业务经营许可证：京B2-20211458 | 增值电信业务经营许可证：B2-20211368 | 广播电视节目制作经营许可证：（京）字第19400号 | 网络文化经营许可证：京网文（2021）2262-606号</p>
        <p><a href="https://images.kxymall.com/MjAyMjAyMjUxNTQ1MTE2Njg3NA==.jpg" target="_blank">营业执照</a> <a href="https://images.kxymall.com/MjAxNjA2MTUyMTA0RVDFDFD3NQ==" target="_blank">食品经营许可证</a></p> -->
        <!-- <p>中国互联网协会互联网企业信用评级A级信用企业</p> -->
        <!-- <p class="cert">
          <a href="http://www.itrust.org.cn/Home/Index/itrust_certifi?wm=1A0021QN4C" target="_blank">
            <img src="https://static.kxymall.com/images/wangxin.png" width="118"> </a>
          <a href="https://trustsealinfo.websecurity.norton.com/splash?form_file=fdf/splash.fdf&amp;dn=www.kxymall.com&amp;lang=zh_cn"
            target="_blank" style="margin:0 10px 0 3px"><img src="https://static.kxymall.com/images/norton.png"></a>
          <a target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802021062">
            <img src="https://static.kxymall.com/images/cert_security2.png" width="70"> </a>
        </p> -->
        <!-- <div style="width:300px;margin:0 auto;">
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802021082" style="display:inline-block;text-decoration:underline;height:20px;line-height:20px;">
            <img src="../../../assets/images/备案图标.png" style="float:left;" />
            <p style="float:left;height:20px;line-height:10px;margin: 0px 0px 0px 5px;" class="underline"><span>京公网安备&nbsp;11010802021082号</span></p>
          </a>
        </div>
        <p>地址：北京市海淀区中关村大街27号15层1503-3 电话：010-53686909</p> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fMenu: [
        {
          name: "新手指南",
          children: [
            {
              name: "商城免费会员",
              router: { path: "/help", query: { articleid: 15 } },
            },
            {
              name: "账户管理",
              router: { path: "/help", query: { articleid: 16 } },
            },
            {
              name: "购物流程",
              router: { path: "/help", query: { articleid: 17 } },
            },
            {
              name: "常见问题汇总",
              router: { path: "/help", query: { articleid: 18 } },
            },
          ],
        },
        {
          name: "支付",
          children: [
            {
              name: "在线支付",
              router: { path: "/help", query: { articleid: 19 } },
            },
            {
              name: "线下扫码",
              router: { path: "/help", query: { articleid: 20 } },
            },
          ],
        },
        {
          name: "配送",
          children: [
            {
              name: "自营商品配送方式",
              router: { path: "/help", query: { articleid: 21 } },
            },
            {
              name: "第三方商品配送方式",
              router: { path: "/help", query: { articleid: 22 } },
            },
            // {
            //   name: "快递查询",
            //   router: "http://m.kuaidi100.com/",
            // },
          ],
        },
        {
          name: "服务",
          children: [
            {
              name: "自营商品售后",
              router: { path: "/help", query: { articleid: 23 } },
            },
            {
              name: "第三方商家商品售后",
              router: { path: "/help", query: { articleid: 24 } },
            },
          ],
        },
        {
          name: "购物条款",
          children: [
            {
              name: "服务条款",
              router: { path: "/help", query: { articleid: 25 } },
            },
            {
              name: "隐私政策",
              router: { path: "/help", query: { articleid: 26 } },
            },
            {
              name: "交易纠纷处理规则",
              router: { path: "/help", query: { articleid: 27 } },
            },
            {
              name: "商家服务协议",
              router: { path: "/help", query: { articleid: 28 } },
            },
            {
              name: "联盟商家入驻服务协议",
              router: { path: "/help", query: { articleid: 29 } },
            },
          ],
        },
        {
          name: "关于网站",
          children: [
            {
              name: " 关于我们",
              router: { path: "/help", query: { articleid: 7 } },
            },
            {
              name: "联系我们",
              router: { path: "/help", query: { articleid: 8 } },
            },
          ],
        },
      ],
    };
  },
};
</script>
<style>
.underline span:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// footer.vue?4a700305